"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconSwapHorizontal = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("./Icon");
// Material Icon
// https://material.io/resources/icons/?search=arrow&icon=swap_horiz&style=baseline
const IconSwapHorizontal = (props) => {
    return (react_1.default.createElement(Icon_1.SVGIcon, { ...props, size: props.size },
        react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
        react_1.default.createElement("path", { d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" })));
};
exports.IconSwapHorizontal = IconSwapHorizontal;
